import { render, staticRenderFns } from "./DataSourceMetaDataModal.vue?vue&type=template&id=51c95976&scoped=true"
import script from "./DataSourceMetaDataModal.vue?vue&type=script&lang=js"
export * from "./DataSourceMetaDataModal.vue?vue&type=script&lang=js"
import style0 from "./DataSourceMetaDataModal.vue?vue&type=style&index=0&id=51c95976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c95976",
  null
  
)

export default component.exports